module.exports = __webpack_public_path__ + "static/media/tecnsys-logo.ba89cbfe.png";